import { useTranslation } from 'react-i18next';
import * as Styled from './LeaderboardItem.styled';
import { getRankIcon, getGfmBaseUrl } from './utils';
import LeaderboardDefaultAvatar from '../../svgs/gfm_leaderboard/LeaderboardDefaultAvatar';
import { formatCurrency } from '../../features/passport/formatCurrency';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const LeaderboardItem = ({
  entry,
  campaignLocale,
  siteBaseUrl
}) => {
  const {
    t
  } = useTranslation('blocks.gfmLeaderboard');
  const rankIcon = getRankIcon(entry.rank);
  return /*#__PURE__*/_jsx(Styled.ItemLink, {
    href: `${getGfmBaseUrl(siteBaseUrl)}/f/${entry.slug}`,
    children: /*#__PURE__*/_jsxs(Styled.ItemContainer, {
      rank: entry.rank,
      children: [/*#__PURE__*/_jsx(Styled.RankSection, {
        children: rankIcon ? /*#__PURE__*/_jsx(Styled.RankBadge, {
          children: rankIcon
        }) : /*#__PURE__*/_jsx(Styled.RankNumber, {
          children: entry.rank
        })
      }), /*#__PURE__*/_jsx(Styled.AvatarSection, {
        children: entry.profileImage ? /*#__PURE__*/_jsx(Styled.ProfileImage, {
          src: entry.profileImage,
          alt: entry.name
        }) : /*#__PURE__*/_jsx(Styled.DefaultAvatarWrapper, {
          children: /*#__PURE__*/_jsx(LeaderboardDefaultAvatar, {})
        })
      }), /*#__PURE__*/_jsxs(Styled.ContentSection, {
        children: [/*#__PURE__*/_jsx(Styled.ParticipantName, {
          children: entry.name
        }), /*#__PURE__*/_jsx(Styled.CampaignTitle, {
          children: entry.campaignTitle
        })]
      }), /*#__PURE__*/_jsxs(Styled.AmountSection, {
        children: [/*#__PURE__*/_jsx(Styled.Amount, {
          children: formatCurrency({
            amount: entry.amountRaised,
            currencyCode: entry.currencyCode,
            locale: campaignLocale || 'en-US'
          })
        }), /*#__PURE__*/_jsx(Styled.RaisedLabel, {
          children: t('GfmLeaderboard.raisedLabel', 'raised')
        })]
      })]
    })
  });
};
export default LeaderboardItem;